
import React from 'react';
import { Sparkles, CalendarDays, Users } from 'lucide-react';

export const FeatureList: React.FC = () => {
  return (
    <div className="flex flex-wrap gap-4 my-6">
      <div className="flex items-center space-x-2">
        <div className="bg-hormony-coral/10 p-2 rounded-full">
          <Sparkles className="h-4 w-4 text-hormony-coral" />
        </div>
        <span className="text-sm">Instant insights</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <div className="bg-hormony-coral/10 p-2 rounded-full">
          <CalendarDays className="h-4 w-4 text-hormony-coral" />
        </div>
        <span className="text-sm">Personalized tracking</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <div className="bg-hormony-coral/10 p-2 rounded-full">
          <Users className="h-4 w-4 text-hormony-coral" />
        </div>
        <span className="text-sm">Expert recommendations</span>
      </div>
    </div>
  );
};
